import React from 'react';
import { cn } from '../../lib/utils'; // We'll need a simple utility for class merging or just use template literals if preferred. I'll stick to template literals for simplicity in this context.
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'white' | 'light' | 'warm';
  id?: string;
}
export function Section({
  children,
  className = '',
  background = 'warm',
  id
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    light: 'bg-[#D8F3DC]/30',
    warm: 'bg-[#FAFAF8]'
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-234">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-235">{children}</div>
    </section>;
}